import { z } from 'zod';

/** starts with a letter or underscore, then letters, numbers, underscores, or dollar signs */
const CODE_IDENTIFIER_REGEX = /^(?!\d)[A-Za-z_$][A-Za-z0-9_$]*$/;

const codeIdentifierSchema = z
  .string()
  .min(3, 'Code identifier must be at least 3 characters')
  .max(150, 'Code identifier must be at most 150 characters')
  .regex(
    CODE_IDENTIFIER_REGEX,
    'Code identifier must start with a letter, "_" or "$" and contain only letters, numbers, "_" or "$"'
  );

export function validateCodeIdentifier(value: string): true | string {
  const result = codeIdentifierSchema.safeParse(value);
  if (result.success) {
    return true;
  }
  const first = result.error.errors[0];
  return first?.message ?? 'Invalid code identifier';
}
